import {
  CHART_PNL_LIVE_FEED,
  CHART_UNDERLYINNG_PNL_LIVE_FEED,
  SYMBOL_LIVE_FEED,
  UNDERLYING_LIVE_FEED,
} from './ActionTypes';

export default {
  1001: UNDERLYING_LIVE_FEED,
  1002: SYMBOL_LIVE_FEED,
  1003: CHART_PNL_LIVE_FEED,
  1004: CHART_UNDERLYINNG_PNL_LIVE_FEED,
};
